import { useNavigate } from "react-router-dom";
import { ArrowRight, Play } from "lucide-react";

const Cases = () => {
  const navigate = useNavigate();

  const cases = [
    {
      slug: "maybach-landaulet-film",
      title: "Maybach Landaulet Film",
      subtitle: "Luxus-Automotive-Produktion für eines von 3 Exemplaren weltweit",
      category: "Luxury Brand Film",
      metrics: "Premium Production",
      image: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/xv0864mm-maybach-landaulet-1-12-1.jpg",
    },
    {
      slug: "geiger-group",
      title: "Geiger Group",
      subtitle: "Langjährige Partnerschaft – Kundenzufriedenheit & EM 2024 Kampagne",
      category: "Corporate Campaign",
      metrics: "Multiple Videos",
      image: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/pisul96k-kundenzufriedenheit.jpg",
    },
    {
      slug: "dubai-reel-package",
      title: "Dubai Luxury Cars",
      subtitle: "15–20 Reels für Autovermietung – Porsche, Lamborghini, Rolls-Royce",
      category: "Social Content",
      metrics: "15-20 Reels",
      image: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/s9ixizez-dsc9930.jpg",
    },
    {
      slug: "seedos-product-campaign",
      title: "Seedos Product Campaign",
      subtitle: "Social Content & Produktfilm für Sonnenblumenkerne-Brand",
      category: "Product & Brand",
      metrics: "3 Videos",
      image: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/bts-seedos-set.webp",
    },
    {
      slug: "stadt-villingen-schwenningen",
      title: "Stadt Villingen-Schwenningen",
      subtitle: "Weihnachts- & Wochenmärkte: Image + Bewerbung",
      category: "City Campaign",
      metrics: "6+ Videos",
      image: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/ai8k1htb-rueckblick-vs-thumbnail-1-13-1.jpg",
    },
    {
      slug: "startup-foerderung-vs",
      title: "Startup-Förderung VS",
      subtitle: "4 Hero-Videos + BTS Social (mit Daniel Hofmeier)",
      category: "Campaign",
      metrics: "4 Hero-Videos",
      image: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/sveufg2j-thumbnail-start-up-foerderung.png",
    },
  ];

  return (
    <section className="py-24 bg-background" data-testid="cases-section">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header — editorial, linksbündig */}
        <div className="mb-14 max-w-3xl">
          <div className="inline-flex items-center gap-3 mb-5 text-xs font-semibold uppercase tracking-[0.28em] text-[hsl(var(--accent))]">
            <span className="w-10 h-px bg-[hsl(var(--accent))]/60" />
            Portfolio
          </div>
          <h2
            className="text-4xl sm:text-6xl font-bold leading-[1.03] tracking-tight"
            data-testid="cases-title"
          >
            Projekte, die <span className="text-[hsl(var(--accent))]">wirken</span>.
          </h2>
          <p className="text-lg text-muted-foreground mt-5 max-w-xl">
            Von Automotive über Stadt-Kampagnen bis Social Content — eine Auswahl
            meiner Arbeiten für Marken, die auffallen wollen.
          </p>
        </div>

        {/* Cases Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {cases.map((caseItem, index) => (
            <div
              key={index}
              onClick={() => navigate(`/case/${caseItem.slug}`)}
              className="group relative bg-secondary/30 rounded-2xl overflow-hidden cursor-pointer hover-tilt"
              data-testid={`case-card-${index}`}
            >
              {/* Image/Video Placeholder */}
              <div className="aspect-video bg-gradient-to-br from-slate-800 via-purple-900/20 to-slate-900 relative overflow-hidden">
                {/* When user provides image/video */}
                {caseItem.image && (
                  <img
                    src={caseItem.image}
                    alt={caseItem.title}
                    className="w-full h-full object-cover"
                  />
                )}
                
                {/* Hover overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-6 right-6">
                    <div className="w-12 h-12 rounded-full bg-[hsl(var(--accent))] flex items-center justify-center">
                      <ArrowRight className="w-6 h-6 text-white" />
                    </div>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="px-3 py-1 text-xs font-medium bg-[hsl(var(--accent))]/20 text-[hsl(var(--accent))] rounded-full">
                    {caseItem.category}
                  </span>
                  <span className="text-sm text-muted-foreground">
                    {caseItem.metrics}
                  </span>
                </div>
                <h3 className="text-2xl font-bold mb-2 group-hover:text-[hsl(var(--accent))] transition-colors" data-testid={`case-title-${index}`}>
                  {caseItem.title}
                </h3>
                <p className="text-muted-foreground">
                  {caseItem.subtitle}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Cases;
